import { gql } from '@apollo/client';

const PROJECT_CONTRIBUTOR_FRAGMENT = gql`
  fragment ProjectContributorFragment on ProjectContributorInterface {
    id
    databaseId
    webURL
    name
    avatar
    initials
    companyId
    companyName
  }
`;

export default gql`
  fragment TaskFragment on Task {
    id
    title
    position
    details
    instructions
    referencePhotos {
      id
      url
      thumbnailUrl
    }
    completed
    completedBy {
      id
      name
      company {
        id
        name
        avatar
        accentColor
      }
    }
    completedAt
    photoCaptureRequired
    taskListSection {
      __typename
      position
      title
      id
    }
    subTasks {
      __typename
      nodes {
        answerType
        answerOptions
        answerChoices
        answerText
        id
        label
      }
    }
    images {
      __typename
      nodes {
        id
        databaseId
        assetPreviewThumbnail
        assetPreviewLarge
        contributor {
          ... on ProjectContributorInterface {
            ...ProjectContributorFragment
          }
        }
        originalUris(variants: [ORIGINAL, MEDIUM, THUMBNAIL]) {
          __typename
          variant
          uri
        }
        capturedAt
        project {
          __typename
          databaseId
          formattedLine1
          formattedLine2
          id
        }
        projectInfo {
          __typename
          databaseId
          formattedLine1
          formattedLine2
          id
        }
      }
    }
  }
  ${PROJECT_CONTRIBUTOR_FRAGMENT}
`;
